export const initShare = () => 
{
	const shareButtons = Array.from(document.querySelectorAll( 'div.share' ));

	if ( !shareButtons.length )
	{
		return;
	}

	shareButtons.forEach( ( button ) => {
		const divLikely = button.querySelector( 'div.likely' );
		const copyButton = divLikely.querySelector( 'div[data-label="copy"]' );
		const links = divLikely.querySelectorAll( 'a' );
		
		const hideButtons = (evt) => {
			if ( evt.target.closest( 'div.likely' ) !== divLikely )
			{
				divLikely.classList.remove( 'visible' );
				button.querySelector( 'button' ).classList.remove(`active`);
				document.removeEventListener( 'click', hideButtons );
			}
		};

		links.forEach( link => {
			link.href += location.href;
		})

		button.addEventListener( 'click', ( evt ) => {
			button.querySelector( 'button' ).classList.add(`active`);
			
			if ( !divLikely.classList.contains( 'visible' ) )
			{
				evt.stopPropagation();
				divLikely.classList.add( 'visible' );
				document.addEventListener( 'click', hideButtons );
			}
		});

		copyButton.addEventListener( 'click', () => {
			window.getSelection().removeAllRanges();

			const elem = document.createElement( 'div' );
			elem.textContent = location.href;
			document.body.appendChild( elem );

			const range = document.createRange();
			range.selectNode( elem );
			window.getSelection().addRange( range );

			try
			{
				document.execCommand( 'copy' );
				copyButton.setAttribute( 'disabled', '' );
			} catch(err) {
				console.log( err );
			}

			window.getSelection().removeAllRanges();
			elem.remove();

			copyButton.classList.add('success');

			setTimeout( () =>
			{
				copyButton.removeAttribute( 'disabled' );
				copyButton.classList.remove('success');
			}, 2000 );
		});
	});
};
